import React from 'react';
import { connect } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';

import alertActions from '../actions/alertActions';

class Alert extends React.Component {
	handleClose = () => {
		this.props.dispatch(alertActions.clear());
	}

	render() {
		return (
			<Snackbar 
				open={this.props.open}
				onClose={this.handleClose}
				anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				message={<span id="message-id"><strong>{this.props.type}:</strong> {this.props.message}</span>}
			/>
		);
	}
}

function mapStateToProps(state) {
	const { alert } = state.alert;
	return { alert };
}

export default connect(mapStateToProps)(Alert);



// WEBPACK FOOTER //
// ./src/components/Alert.js